import api from "./api";

export const AdminUsersAPI = {
  // Users
  list: () => api("/admin/users"),

  create: (payload) =>
    api("/admin/users", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  update: (id, payload) =>
    api(`/admin/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),

  remove: (id) =>
    api(`/admin/users/${id}`, {
      method: "DELETE",
    }),

  // Security
  setPassword: (id, password) =>
    api(`/admin/users/${id}/password`, {
      method: "PATCH",
      body: JSON.stringify({ password }),
    }),

  // Roles / assignments
  getRolesForUser: (id) => api(`/admin/users/${id}/roles`),

  setRolesForUser: (id, assignments) =>
    api(`/admin/users/${id}/roles`, {
      method: "PUT",
      body: JSON.stringify({ assignments }),
    }),

  /**
   * Backwards compatibility
   * TODO: remove once all callers are migrated
   */
  setRolesForStaff(id, assignments) {
    return this.setRolesForUser(id, assignments);
  },
};